import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { CancelCampaignDialog } from '@/components/campaigns/cancel-campaign-dialog';
import { Button } from '@/components/ui/button';
import { useI18nContext } from '@/i18n/i18n-react';
import { mobileLayer } from '@/lib/mobile-layer';

/**
 * Fixed bottom bar of the campaign details below 768px (PUSH-10 AC 2):
 * Duplicar and, while the campaign was not sent, Cancelar with the
 * confirmation. The dialog stays open while cancelling and closes when it
 * settles (a 409 keeps the user on the refreshed detail).
 */
export function CampaignDetailsActionBar({
  campaignName,
  duplicateHref,
  canCancel,
  isCancelling,
  onCancelConfirm,
}: {
  campaignName: string;
  duplicateHref: string;
  canCancel: boolean;
  isCancelling: boolean;
  onCancelConfirm(): void;
}) {
  const { LL } = useI18nContext();
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (!isCancelling) setConfirmOpen(false);
  }, [isCancelling]);

  return (
    <div
      role="group"
      aria-label={LL.campaigns.actionsSheet.description()}
      className="sticky bottom-0 z-10 -mx-8 mt-auto flex gap-2 border-t bg-background px-4 py-3"
    >
      <Button
        asChild
        variant="outline"
        className={`flex-1 ${mobileLayer.touch}`}
      >
        <Link to={duplicateHref}>{LL.campaigns.actionsSheet.duplicate()}</Link>
      </Button>
      {canCancel && (
        <Button
          type="button"
          variant="outline"
          className={`flex-1 text-destructive hover:text-destructive ${mobileLayer.touch}`}
          onClick={() => setConfirmOpen(true)}
        >
          {LL.campaigns.actionsSheet.cancel()}
        </Button>
      )}
      <CancelCampaignDialog
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        campaignName={campaignName}
        isPending={isCancelling}
        onConfirm={onCancelConfirm}
      />
    </div>
  );
}
